import(/* webpackMode: "eager" */ "/home/runner/work/landing/landing/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/work/landing/landing/src/app/providers.tsx");
